
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/for-companies",
      function () {
        return require("private-next-pages/fr/for-companies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/for-companies"])
      });
    }
  